import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {useCommonContext} from "../../../contexts/CommonContext";
import NewArticleDeliveryStore from "./NewArticleDeliveryStore";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./NewArticleDeliveryButton.style";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import Steppers from '../../../ui_components/Stepper/Steppers';
import StepperOption from '../../../ui_components/Stepper/StepperOption';
import ArticleSelect from './ArticleSelect/ArticleSelect';
import AdditionalPrices from './AdditionalPrice/AdditionalPrices/AdditionalPrices';
import ArticleDeliveryResume from './Resume/ArticleDeliveryResume';
import ContactSelect from './ContactSelect/ContactSelect';
import NewArticleDeliveryButtonProperties from './NewArticleDeliveryButtonProperties';
import SidePanel from '../../../ui_components/SidePanel/SidePanel';
import Access from '../../Access/AllowAccess/Access';
import { useUserContext } from '../../../contexts/UserContext';
import AgencySelect from './AgencySelect/AgencySelect';
import Payment from './Payment/Payment';
import FastfoodIcon from '@mui/icons-material/Fastfood';


const NewArticleDeliveryButton: React.FC<NewArticleDeliveryButtonProperties> = ({
                                                                                                onClick = () => {
                                                                                                },
                                                                                                showIcon = true,
                                                                                                onSave = () => {
                                                                                                },
                                                                                                showText = true,
                                                                                                disabled,
                                                                                                className = '',
                                                                                                rounded = false,
                                                                                                size = ButtonSize.DEFAULT,
                                                                                                type = ButtonType.DEFAULT
                                                                                            }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();

    const store = new NewArticleDeliveryStore(commonContext, userStore);

    const handleOnclick = async () => {
        onClick();
        await store.openModal();
    }

    const onCloseModal = () => {
        store.createAnother = false;
        store.closeModal();
    }

    const isAgencySelected = (): boolean => {
        if (!store.selectedAgency) return true;
        return !!store.selectedSeller?.id
    }

    const isSelectArticleStepCompleted = (): boolean => {
        return store.selectedArticles.length > 0;
    }

    const isContactStepCompleted = (): boolean => {
        return store.selectedContact?.clientId != null;
    }

    const text = showText ? i18n.translate("NEW_ARTICLE_DELIVERY") : "";
    const tooltip = !showText ? i18n.translate("NEW_ARTICLE_DELIVERY") : "";
    const btnIcon = showIcon ? <FastfoodIcon/> : React.Fragment;

    let index = 0;
    let steps: StepperOption[] = [];
    if (userStore.hasAccess(Access.SEND_ORDERS_TO_AGENCIES) && userStore.hasAccess(Access.LIST_AGENCY)) {
        steps.push(new StepperOption(index++, i18n.translate("SELECT_AGENCY"), isAgencySelected, <AgencySelect
            store={store}/>))
    }
    steps.push(new StepperOption(0, i18n.translate("SELECT_ARTICLE"), isSelectArticleStepCompleted, <ArticleSelect
        store={store}/>));
    steps.push(new StepperOption(1, i18n.translate("SELECT_CONTACT_PLACEHOLDER"), isContactStepCompleted, <ContactSelect
            store={store}/>));
    steps.push(new StepperOption(2, "Precios y tarifas", () => true, <AdditionalPrices
            store={store}/>, () => {}));
    steps.push(new StepperOption(index++, i18n.translate("PAYMENT"), () => {
        return true;
    }, <Payment
        store={store}/>));
    steps.push(new StepperOption(3, i18n.translate("RESUME"), () => {
            return false;
        }, <ArticleDeliveryResume store={store}/>));

    const handleFinish = () => {
        store.createArticleDelivery();
        if (onSave) {
            onSave();
        }
    };

    const onCreateAnotherChange = (value: boolean) => {
        store.createAnother = value;
    };

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                className={className}
                onClick={handleOnclick}
                tooltip={tooltip}
                disabled={disabled}
                size={size}
                type={type}
                text={text}
                icon={btnIcon}
            />
        }
        return <Button
            className={className}
            onClick={handleOnclick}
            tooltip={tooltip}
            disabled={disabled}
            size={size}
            type={type}
            text={text}
            startIcon={btnIcon}
        />
    }

    return <Observer>
        {() => (
            <>
                <SidePanel title={i18n.translate("NEW_ARTICLE_DELIVERY")} onClose={onCloseModal}
                           open={store.isModalOpen} className={classes.modal_container}>
                    {!store.response &&
                        <Steppers 
                            activeStep={store.activeStep}
                            onActiveStepChange={(value) => {
                                store.activeStep = value;
                            }}
                            steps={steps} containerClassName={classes.stepper_container}
                            bottomLeftCheckboxText={'Crear otro envío para el mismo cliente'}
                            onBottomLeftCheckboxChange={onCreateAnotherChange}
                            handleFinish={handleFinish} finishButtonLoading={store.finishButtonLoading}/>}    
                </SidePanel>
                <Btn/>
            </>
        )}
    </Observer>
}

export default NewArticleDeliveryButton;
